module.exports = {
  "information": {
    information: "资讯",
    minutes: "分钟之前",
    hours: "小时之前",
  },
}


// WEBPACK FOOTER //
// ./src/i18n/information/zh-CN.js